import http from "@/settings/apiSettings"

class StructuriActivitatiService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_StructuriActivitati", data)
    }
}
export default new StructuriActivitatiService()